import * as React from "react";
import InnerPage from "../components/InnerPage";
import UserGroupManager from "../components/UserGroupManager";

export default function UserGroupsScreen({ user }) {
  return (
    <InnerPage title="Manage User Groups">
      <UserGroupManager user={user} />
    </InnerPage>
  );
}
